import { useParams, usePathname } from 'next/navigation';

// Lib
import { HOMEPAGE } from '@/lib/routes/privateRoutes';
import { userPermissionsHasAccess } from '@/lib/acl/pageHasAccess';

// Utils
import { formatObjectWithUrlKeys } from '@/utils/urls/formatUrl';
import useAcl from '@/utils/hooks/user/useAcl';

export const usePageHasPermissions = () => {
    const { hasAcl } = useAcl();
    const params = useParams();

    /**
     * Replace url parameters with the real value
     */
    const formattedUrl = formatObjectWithUrlKeys(userPermissionsHasAccess, params);

    const checkPagePermissions = (pathname: string) => {
        if (!(pathname in formattedUrl)) {
            return {
                pageHasPermissions: true
            };
        }

        return {
            pageHasPermissions: hasAcl(formattedUrl[pathname])
        };
    };

    return { checkPagePermissions };
};

export const useRequiresPermissions = () => {
    const pathname = usePathname();
    const { checkPagePermissions } = usePageHasPermissions();

    const { pageHasPermissions } = checkPagePermissions(pathname);

    return { hasAccess: pageHasPermissions, redirect_url: HOMEPAGE };
};
